import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import Navbar from "../components/Header/Navbar"
import TopSection from "../components/LandingPage/TopSection";
import FeaturedBusinesses from "../components/LandingPage/FeaturedSection";
import Footer from "../components/Footer/Footer";

const LandingPage = () => {
  useEffect(() => {

  });
  return (
    <Grid>
      <Navbar/>
      <TopSection />
      <FeaturedBusinesses />
      <Footer />
    </Grid>
  );
};

export default LandingPage;
